// // screens/marketplace/AdminOrderFulfillment.jsx
// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import {
//   Package,
//   RefreshCw,
//   Search,
//   ChevronDown,
//   ChevronRight,
//   ArrowRight,
//   CheckCircle2,
//   XCircle,
//   AlertCircle,
//   Truck,
//   X,
//   Save,
//   Inbox,
// } from "lucide-react";
// import { useAuth } from "../../providers/AuthProvider";
// import { useToast } from "../../providers/ToastProvider";
// import {
//   PageShell,
//   Section,
//   Button,
//   Field,
//   Input,
//   Select,
//   EmptyState,
//   LoadingBlock,
//   useTokens,
// } from "./shared";

// /* ══════════════════════════════════════════════════════════
//    The 12 pipeline statuses, in forward order. FAILED and
//    CANCELLED are terminal and handled separately.
//    ══════════════════════════════════════════════════════════ */

// const STATUS_FLOW = [
//   { value: "ORDER_CONFIRMED", label: "Order Confirmed" },
//   { value: "SHOPPING_IN_PROGRESS", label: "Shopping in Progress" },
//   { value: "PURCHASED", label: "Purchased" },
//   { value: "IN_TRANSIT_TO_CHINA", label: "In Transit to China Warehouse" },
//   { value: "RECEIVED_AT_CHINA", label: "Received at China Warehouse" },
//   { value: "INSPECTION_IN_PROGRESS", label: "Inspection in Progress" },
//   { value: "PREPARING_FOR_SHIPMENT", label: "Preparing for Shipment" },
//   { value: "SHIPPED_FROM_CHINA", label: "Shipped from China" },
//   { value: "ARRIVED_IN_GHANA", label: "Arrived in Ghana" },
//   { value: "READY_FOR_PICKUP", label: "Ready for Pickup" },
//   { value: "OUT_FOR_DELIVERY", label: "Out for Delivery" },
//   { value: "DELIVERED_SUCCESSFULLY", label: "Delivered Successfully" },
// ];

// const TERMINAL_STATUSES = [
//   { value: "FAILED", label: "Failed", tone: "error" },
//   { value: "CANCELLED", label: "Cancelled", tone: "muted" },
// ];

// const STATUS_BY_VALUE = Object.fromEntries(
//   STATUS_FLOW.map((s, i) => [s.value, { ...s, index: i }])
// );

// const statusIndex = (value) => {
//   const s = STATUS_BY_VALUE[value];
//   return s ? s.index : -1;
// };

// const statusMeta = (value) => {
//   if (value === "FAILED")
//     return { label: "Failed", tone: "error" };
//   if (value === "CANCELLED")
//     return { label: "Cancelled", tone: "muted" };
//   return STATUS_BY_VALUE[value] || { label: value || "Unknown", tone: "muted" };
// };

// const statusColor = (t, tone) => {
//   const map = {
//     error: { fg: t.error, bg: t.errorBg },
//     muted: { fg: t.muted, bg: t.subtle },
//     success: { fg: t.success, bg: t.successBg },
//     warning: { fg: t.warning, bg: t.warningBg },
//     info: { fg: t.accent, bg: t.hoverBg },
//   };
//   return map[tone] || map.muted;
// };

// /* ══════════════════════════════════════════════════════════
//    The group that owns the fee prompt
//    ══════════════════════════════════════════════════════════ */

// const FEE_TRIGGER_INDEX = statusIndex("ARRIVED_IN_GHANA");
// const isFeeEligibleStatus = (status) =>
//   statusIndex(status) >= FEE_TRIGGER_INDEX && statusIndex(status) >= 0;

// const itemNeedsFee = (item) =>
//   isFeeEligibleStatus(item.status) &&
//   (item.shipping_fee == null || Number(item.shipping_fee) === 0);

// const itemFeeLocked = (item) =>
//   item.shipping_payment_status === "COMPLETED";

// /* ══════════════════════════════════════════════════════════
//    Read — orders + items
//    ══════════════════════════════════════════════════════════ */

// const readApiError = (data, fallback) => {
//   if (!data) return fallback;
//   if (data.message) return data.message;
//   const errs = data.errors;
//   if (errs) {
//     const parts = [];
//     for (const [key, val] of Object.entries(errs)) {
//       const arr = Array.isArray(val) ? val : [val];
//       arr.forEach((msg) => {
//         if (key === "non_field_errors" || key === "detail") parts.push(msg);
//         else parts.push(`${key.replace(/_/g, " ")}: ${msg}`);
//       });
//     }
//     if (parts.length) return parts.join(" ");
//   }
//   return fallback;
// };

// export default function AdminOrderFulfillment() {
//   const { authFetch } = useAuth();
//   const { showToast } = useToast();
//   const t = useTokens();

//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const [search, setSearch] = useState("");
//   const [openGroups, setOpenGroups] = useState(() => new Set(["ARRIVED_IN_GHANA"]));
//   const [modal, setModal] = useState(null);
//   const [busyItemIds, setBusyItemIds] = useState(() => new Set());
//   const [showOnlyNeedsAction, setShowOnlyNeedsAction] = useState(false);

//   const load = useCallback(
//     async ({ silent } = {}) => {
//       if (!silent) setLoading(true);
//       else setRefreshing(true);
//       try {
//         const res = await authFetch("/marketplace/orders/");
//         const data = await res.json();
//         if (!res.ok) throw new Error(readApiError(data, "Could not load orders"));
//         setOrders(data.data || []);
//       } catch (err) {
//         showToast(err.message, "error");
//       } finally {
//         setLoading(false);
//         setRefreshing(false);
//       }
//     },
//     [authFetch, showToast]
//   );

//   useEffect(() => {
//     load();
//   }, [load]);

//   /* Flatten every order item into a single array of
//      { order, item } pairs so we can group across orders. */
//   const allItems = useMemo(() => {
//     const rows = [];
//     orders.forEach((order) => {
//       (order.items || []).forEach((item) => {
//         rows.push({ order, item });
//       });
//     });
//     return rows;
//   }, [orders]);

// const filteredItems = useMemo(() => {
//   const q = search.trim().toLowerCase();
//   let list = allItems;

//   if (showOnlyNeedsAction) {
//     list = list.filter(({ item }) => {
//       if (item.shipping_payment_status !== "COMPLETED") return false;
//       const idx = statusIndex(item.status);
//       return idx >= FEE_TRIGGER_INDEX && idx < 11;
//     });
//   }

//   if (!q) return list;
//   return list.filter(({ order, item }) => {
//     return (
//       (item.product_name_display || "").toLowerCase().includes(q) ||
//       (order.id || "").toLowerCase().includes(q) ||
//       (item.variant_key || "").toLowerCase().includes(q)
//     );
//   });
// }, [allItems, search, showOnlyNeedsAction]);


//   /* Items where the buyer has paid shipping but the item hasn't
//    moved past ARRIVED_IN_GHANA yet — the admin should advance them.
//    Computed from allItems (unfiltered) so the strip always reflects
//    everything, regardless of the search box. */
//   const needsActionItems = useMemo(() => {
//     return allItems.filter(({ item }) => {
//       if (item.shipping_payment_status !== "COMPLETED") return false;
//       const idx = statusIndex(item.status);
//       return idx >= FEE_TRIGGER_INDEX && idx < 11;
//     });
//   }, [allItems]);

//   /* Group by item status. Order the groups by the pipeline order,
//      with FAILED and CANCELLED at the end. */
//   const grouped = useMemo(() => {
//     const map = new Map();
//     STATUS_FLOW.forEach((s) => map.set(s.value, []));
//     TERMINAL_STATUSES.forEach((s) => map.set(s.value, []));
//     filteredItems.forEach(({ order, item }) => {
//       const key = STATUS_BY_VALUE[item.status] ? item.status : "FAILED";
//       if (!map.has(key)) map.set(key, []);
//       map.get(key).push({ order, item });
//     });
//     // Return in pipeline order, dropping empty groups
//     const ordered = [];
//     [...STATUS_FLOW, ...TERMINAL_STATUSES].forEach((s) => {
//       const rows = map.get(s.value) || [];
//       if (rows.length > 0) ordered.push({ status: s.value, rows });
//     });
//     return ordered;
//   }, [filteredItems]);

//   const toggleGroup = (status) => {
//     setOpenGroups((prev) => {
//       const next = new Set(prev);
//       if (next.has(status)) next.delete(status);
//       else next.add(status);
//       return next;
//     });
//   };

//   const openAdvanceModal = (status, preselected) => {
//     const currentIdx = statusIndex(status);
//     if (currentIdx < 0) {
//       showToast("Terminal items cannot be advanced", "error");
//       return;
//     }
//     const nextStatus = STATUS_FLOW[currentIdx + 1]?.value;
//     setModal({
//       fromStatus: status,
//       targetStatus: nextStatus,
//       preselected: preselected || [],
//     });
//   };

//   const handleBulkAdvance = async (payload, updatedIds, errors) => {
//     if (errors.length > 0 && updatedIds.length > 0) {
//       showToast(
//         `${updatedIds.length} updated · ${errors.length} skipped`,
//         "warning"
//       );
//     } else if (errors.length > 0) {
//       showToast(`${errors.length} skipped`, "error");
//     } else {
//       showToast(
//         `${updatedIds.length} item${updatedIds.length === 1 ? "" : "s"} advanced`,
//         "success"
//       );
//     }
//     setModal(null);
//     await load({ silent: true });
//   };

//   return (
//     <PageShell
//       eyebrow="Fulfilment"
//       title="Order pipeline"
//       subtitle="Move items through the pipeline. Bulk-advance lets you push many items to the next stage in one action, and the shipping fee prompt only appears when items arrive in Ghana."
//       actions={
//         <Button
//           variant="secondary"
//           icon={RefreshCw}
//           onClick={() => load({ silent: true })}
//           disabled={refreshing}
//         >
//           Refresh
//         </Button>
//       }
//     >
//       <div style={{ marginBottom: 16, position: "relative", maxWidth: 420 }}>
//         <Search
//           size={15}
//           color={t.muted}
//           style={{
//             position: "absolute",
//             left: 12,
//             top: "50%",
//             transform: "translateY(-50%)",
//             pointerEvents: "none",
//           }}
//         />
//         <Input
//           placeholder="Search by product, order id, or variant…"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           style={{ paddingLeft: 36 }}
//         />
//       </div>

//       {/* Needs-action strip — items paid & ready to advance */}
//       {!loading && needsActionItems.length > 0 && (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: 12,
//             padding: "12px 14px",
//             borderRadius: 12,
//             background: `${t.success}12`,
//             border: `1px solid ${t.success}55`,
//             marginBottom: 16,
//           }}
//         >
//           <span
//             style={{
//               width: 32,
//               height: 32,
//               borderRadius: 9,
//               background: t.success,
//               color: "#fff",
//               display: "inline-flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//             }}
//           >
//             <CheckCircle2 size={16} />
//           </span>
//           <div style={{ flex: 1, minWidth: 0 }}>
//             <div
//               style={{
//                 fontSize: 13,
//                 fontWeight: 800,
//                 color: t.heading,
//               }}
//             >
//               {needsActionItems.length} item
//               {needsActionItems.length === 1 ? "" : "s"} paid for shipping
//             </div>
//             <div style={{ fontSize: 12, color: t.muted, marginTop: 2 }}>
//               Ready to advance — the buyer has paid their shipping fee.
//             </div>
//           </div>
//           <button
//             type="button"
//             onClick={() => setShowOnlyNeedsAction((v) => !v)}
//             style={{
//               fontSize: 12,
//               fontWeight: 700,
//               color: t.success,
//               background: showOnlyNeedsAction ? t.successBg : "transparent",
//               border: showOnlyNeedsAction ? `1px solid ${t.success}55` : "none",
//               cursor: "pointer",
//               padding: "6px 12px",
//               borderRadius: 8,
//               fontFamily: "inherit",
//             }}
//           >
//             {showOnlyNeedsAction ? "Show all" : "Show only these"}
//           </button>
//         </div>
//       )}

//       {loading ? (
//         <LoadingBlock label="Loading orders…" />
//       ) : grouped.length === 0 ? (
//         <EmptyState
//           icon={Inbox}
//           title={search ? "Nothing matches" : "No open items"}
//           description={
//             search
//               ? "Try a different search term."
//               : "Once buyers place orders, items will appear here grouped by their current stage."
//           }
//         />
//       ) : (
//         <div style={{ display: "grid", gap: 10 }}>
//           {grouped.map((group) => {
//             const meta = statusMeta(group.status);
//             const tone = statusColor(t, meta.tone);
//             const open = openGroups.has(group.status);
//             const needsAttention =
//               group.status === "ARRIVED_IN_GHANA" &&
//               group.rows.some(({ item }) => itemNeedsFee(item));
//             const isTerminal =
//               group.status === "FAILED" || group.status === "CANCELLED";

//             return (
//               <div
//                 key={group.status}
//                 style={{
//                   borderRadius: 12,
//                   border: `1px solid ${needsAttention ? `${t.warning}66` : t.border
//                     }`,
//                   background: t.surfaceRaised,
//                   overflow: "hidden",
//                 }}
//               >
//                 <button
//                   type="button"
//                   onClick={() => toggleGroup(group.status)}
//                   style={{
//                     width: "100%",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 12,
//                     padding: "14px 16px",
//                     background: "transparent",
//                     border: "none",
//                     cursor: "pointer",
//                     fontFamily: "inherit",
//                     textAlign: "left",
//                   }}
//                 >
//                   {open ? (
//                     <ChevronDown size={16} color={t.muted} />
//                   ) : (
//                     <ChevronRight size={16} color={t.muted} />
//                   )}
//                   <span
//                     style={{
//                       fontSize: 14,
//                       fontWeight: 800,
//                       color: t.heading,
//                     }}
//                   >
//                     {meta.label}
//                   </span>
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       padding: "2px 8px",
//                       borderRadius: 999,
//                       background: tone.bg,
//                       color: tone.fg,
//                     }}
//                   >
//                     {group.rows.length}
//                   </span>
//                   {needsAttention && (
//                     <span
//                       style={{
//                         display: "inline-flex",
//                         alignItems: "center",
//                         gap: 4,
//                         fontSize: 11,
//                         fontWeight: 700,
//                         color: t.warning,
//                         padding: "2px 8px",
//                         borderRadius: 999,
//                         background: t.warningBg,
//                       }}
//                     >
//                       <AlertCircle size={11} />
//                       {group.rows.filter(({ item }) => itemNeedsFee(item)).length} needs fee
//                     </span>
//                   )}
//                   <div style={{ flex: 1 }} />
//                   {!isTerminal && (
//                     <span
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         openAdvanceModal(group.status, []);
//                       }}
//                       style={{
//                         display: "inline-flex",
//                         alignItems: "center",
//                         gap: 4,
//                         fontSize: 12.5,
//                         fontWeight: 700,
//                         color: t.accent,
//                         padding: "4px 10px",
//                         borderRadius: 8,
//                         background: `${t.accent}12`,
//                       }}
//                     >
//                       Advance <ArrowRight size={13} />
//                     </span>
//                   )}
//                 </button>

//                 {open && (
//                   <div
//                     style={{
//                       padding: "0 16px 14px",
//                       borderTop: `1px solid ${t.separator || t.border}`,
//                     }}
//                   >
//                     <GroupItems
//                       status={group.status}
//                       rows={group.rows}
//                       t={t}
//                       busyItemIds={busyItemIds}
//                       onAdvance={(ids) => openAdvanceModal(group.status, ids)}
//                     />
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {modal && (
//         <AdvanceModal
//           modal={modal}
//           grouped={grouped}
//           authFetch={authFetch}
//           t={t}
//           busyItemIds={busyItemIds}
//           onBusyChange={setBusyItemIds}
//           onClose={() => setModal(null)}
//           onComplete={handleBulkAdvance}
//         />
//       )}
//     </PageShell>
//   );
// }

// /* ══════════════════════════════════════════════════════════
//    Items inside one status group
//    ══════════════════════════════════════════════════════════ */

// const GroupItems = ({ status, rows, t, busyItemIds, onAdvance }) => {
//   const navigate = useNavigate();
//   const isTerminal = status === "FAILED" || status === "CANCELLED";

//   // Group rows by order so we can show one card per order
//   const byOrder = useMemo(() => {
//     const map = new Map();
//     rows.forEach(({ order, item }) => {
//       if (!map.has(order.id)) map.set(order.id, { order, items: [] });
//       map.get(order.id).items.push(item);
//     });
//     return [...map.values()];
//   }, [rows]);

//   return (
//     <>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           gap: 8,
//           padding: "10px 0",
//         }}
//       >
//         <span style={{ fontSize: 11.5, color: t.muted }}>
//           {rows.length} item{rows.length === 1 ? "" : "s"} across{" "}
//           {byOrder.length} order{byOrder.length === 1 ? "" : "s"}
//         </span>
//       </div>

//       <div style={{ display: "grid", gap: 8 }}>
//         {byOrder.map(({ order, items: orderItems }) => (
//           <button
//             key={order.id}
//             type="button"
//             onClick={() => navigate(`/marketplace/manage/orders/${order.id}`)}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 12,
//               width: "100%",
//               padding: "12px 14px",
//               borderRadius: 10,
//               border: `1px solid ${t.border}`,
//               background: t.raisedBg,
//               cursor: "pointer",
//               fontFamily: "inherit",
//               textAlign: "left",
//               transition: "border-color 0.15s ease, background 0.15s ease",
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.borderColor = t.accent;
//               e.currentTarget.style.background = t.hoverBg;
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.borderColor = t.border;
//               e.currentTarget.style.background = t.raisedBg;
//             }}
//           >
//             <div
//               style={{
//                 width: 32,
//                 height: 32,
//                 borderRadius: 8,
//                 background: t.subtle,
//                 display: "inline-flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//                 color: t.muted,
//               }}
//             >
//               <Package size={15} />
//             </div>
//             <div style={{ flex: 1, minWidth: 0 }}>
//               <div
//                 style={{
//                   fontSize: 13,
//                   fontWeight: 700,
//                   color: t.heading,
//                 }}
//               >
//                 #{String(order.id).slice(0, 8)} ·{" "}
//                 {order.customer_username || "customer"}
//               </div>
//               <div
//                 style={{
//                   fontSize: 11.5,
//                   color: t.muted,
//                   marginTop: 2,
//                 }}
//               >
//                 {orderItems.length} item
//                 {orderItems.length === 1 ? "" : "s"} at this stage
//               </div>
//             </div>
//             <ChevronRight size={16} color={t.muted} />
//           </button>
//         ))}
//       </div>
//     </>
//   );
// };
// const ItemRow = ({ order, item, selected, busy, onToggle, t, selectable }) => {
//   const needsFee = itemNeedsFee(item);
//   const locked = itemFeeLocked(item);
//   const fee = item.shipping_fee != null ? Number(item.shipping_fee) : null;
//   const feeTotal = item.shipping_total != null ? Number(item.shipping_total) : null;

//   return (
//     <div
//       onClick={selectable ? onToggle : undefined}
//       style={{
//         display: "flex",
//         alignItems: "center",
//         gap: 12,
//         padding: "10px 12px",
//         borderRadius: 10,
//         border: `1px solid ${selected ? t.accent : t.border}`,
//         background: selected ? `${t.accent}0A` : t.raisedBg,
//         cursor: selectable ? "pointer" : "default",
//         opacity: busy ? 0.55 : 1,
//         transition: "background 0.12s ease, border-color 0.12s ease",
//       }}
//     >
//       {selectable && (
//         <div
//           style={{
//             width: 18,
//             height: 18,
//             borderRadius: 5,
//             border: `1.5px solid ${selected ? t.accent : t.border}`,
//             background: selected ? t.accent : "transparent",
//             display: "inline-flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexShrink: 0,
//           }}
//         >
//           {selected && (
//             <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
//               <path
//                 d="M2 6.5L4.5 9L10 3"
//                 stroke={t.accentText}
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           )}
//         </div>
//       )}

//       <div
//         style={{
//           width: 36,
//           height: 36,
//           borderRadius: 8,
//           overflow: "hidden",
//           background: t.subtle,
//           flexShrink: 0,
//           display: "inline-flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {item.product_image ? (
//           <img
//             src={item.product_image}
//             alt=""
//             style={{ width: "100%", height: "100%", objectFit: "cover" }}
//           />
//         ) : (
//           <Package size={16} color={t.muted} />
//         )}
//       </div>

//       <div style={{ flex: 1, minWidth: 0 }}>
//         <div
//           style={{
//             fontSize: 13,
//             fontWeight: 700,
//             color: t.heading,
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           {item.product_name_display || item.product_name || "Product"}{" "}
//           <span style={{ color: t.muted, fontWeight: 500 }}>
//             ×{item.quantity}
//           </span>
//         </div>
//         <div
//           style={{
//             fontSize: 11,
//             color: t.muted,
//             marginTop: 2,
//             whiteSpace: "nowrap",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//           }}
//         >
//           #{String(order.id).slice(0, 8)} ·{" "}
//           {item.variant_key ? item.variant_key : "no variant"} ·{" "}
//           {order.customer_username || order.customer || "customer"}
//         </div>
//       </div>

//       {/* Fee state */}
//       <div style={{ flexShrink: 0, textAlign: "right" }}>
//         {needsFee ? (
//           <span
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 4,
//               fontSize: 11,
//               fontWeight: 700,
//               color: t.warning,
//               padding: "3px 8px",
//               borderRadius: 999,
//               background: t.warningBg,
//             }}
//           >
//             <AlertCircle size={11} />
//             Fee unset
//           </span>
//         ) : fee != null ? (
//           <span
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: 4,
//               fontSize: 11,
//               fontWeight: 700,
//               color: locked ? t.success : t.text,
//               padding: "3px 8px",
//               borderRadius: 999,
//               background: locked ? t.successBg : t.subtle,
//             }}
//           >
//             {locked ? <CheckCircle2 size={11} /> : <Truck size={11} />}
//             ₵{fee.toFixed(2)}/unit
//             {feeTotal != null && (
//               <span style={{ color: t.muted, fontWeight: 500 }}>
//                 · ₵{feeTotal.toFixed(2)}
//               </span>
//             )}
//           </span>
//         ) : null}
//       </div>
//     </div>
//   );
// };

// /* ══════════════════════════════════════════════════════════
//    Advance modal
//    ══════════════════════════════════════════════════════════ */

// const AdvanceModal = ({
//   modal,
//   grouped,
//   authFetch,
//   t,
//   busyItemIds,
//   onBusyChange,
//   onClose,
//   onComplete,
// }) => {
//   const [targetStatus, setTargetStatus] = useState(modal.targetStatus || "");
//   const [feeInput, setFeeInput] = useState("");
//   const [editingFees, setEditingFees] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [errors, setErrors] = useState({});

//   const allRows = useMemo(() => {
//     return grouped.flatMap((g) => g.rows);
//   }, [grouped]);

//   /* Selected items — either the ones preselected by the caller,
//      or every item in the current group. */
//   const selectedRows = useMemo(() => {
//     const rowsInGroup = allRows.filter(({ item }) => {
//       return modal.preselected.includes(item.id);
//     });
//     if (rowsInGroup.length > 0) return rowsInGroup;
//     const group = grouped.find((g) => g.status === modal.fromStatus);
//     return group ? group.rows : [];
//   }, [allRows, grouped, modal]);

//   const currentIdx = statusIndex(modal.fromStatus);
//   const targetIdx = statusIndex(targetStatus);
//   const advancingForward = targetIdx > currentIdx;

//   const missingFee = useMemo(() => {
//     if (targetIdx < FEE_TRIGGER_INDEX) return [];
//     return selectedRows.filter(
//       ({ item }) => item.shipping_fee == null || Number(item.shipping_fee) === 0
//     );
//   }, [selectedRows, targetIdx]);

//   const anyLocked = useMemo(
//     () => selectedRows.some(({ item }) => itemFeeLocked(item)),
//     [selectedRows]
//   );

//   const requiresFee = missingFee.length > 0;

//   const submit = async () => {
//     setErrors({});

//     if (!advancingForward) {
//       setErrors({ _general: "Pick a status further along the pipeline" });
//       return;
//     }
//     if (requiresFee && (!feeInput || Number(feeInput) <= 0)) {
//       setErrors({ fee: "Enter a shipping fee for the selected items" });
//       return;
//     }

//     const items = selectedRows.map(({ item }) => {
//       const entry = { order_item_id: item.id, status: targetStatus };
//       if (requiresFee && feeInput) entry.shipping_fee = feeInput;
//       return entry;
//     });

//     setSubmitting(true);
//     onBusyChange(new Set(selectedRows.map(({ item }) => item.id)));
//     try {
//       const res = await authFetch("/marketplace/orders/items/bulk-advance/", {
//         method: "POST",
//         body: JSON.stringify({ items }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(readApiError(data, "Could not advance"));

//       const updated = data.data || [];
//       const failures = data.errors || [];
//       const updatedIds = updated.map((u) => u.id);
//       onComplete(updated, updatedIds, failures);
//     } catch (err) {
//       setErrors({ _general: err.message });
//     } finally {
//       onBusyChange(new Set());
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div
//       onClick={(e) => e.target === e.currentTarget && !submitting && onClose()}
//       style={{
//         position: "fixed",
//         inset: 0,
//         background: t.scrim,
//         backdropFilter: "blur(6px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 1000,
//         padding: 16,
//       }}
//     >
//       <form
//         onSubmit={(e) => {
//           e.preventDefault();
//           submit();
//         }}
//         style={{
//           background: t.surfaceRaised,
//           border: `1px solid ${t.border}`,
//           borderRadius: 16,
//           width: "100%",
//           maxWidth: 540,
//           padding: 24,
//           boxShadow: `0 24px 64px ${t.shadowStrong}`,
//           display: "flex",
//           flexDirection: "column",
//           gap: 16,
//           maxHeight: "90vh",
//           overflowY: "auto",
//         }}
//       >
//         <header
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             gap: 12,
//           }}
//         >
//           <div>
//             <div
//               style={{
//                 fontSize: 16,
//                 fontWeight: 800,
//                 color: t.heading,
//                 letterSpacing: "-0.01em",
//               }}
//             >
//               Advance {selectedRows.length} item
//               {selectedRows.length === 1 ? "" : "s"}
//             </div>
//             <div style={{ fontSize: 12.5, color: t.muted, marginTop: 3 }}>
//               From {statusMeta(modal.fromStatus).label}
//             </div>
//           </div>
//           <button
//             type="button"
//             onClick={onClose}
//             aria-label="Close"
//             disabled={submitting}
//             style={{
//               width: 32,
//               height: 32,
//               borderRadius: 8,
//               border: "none",
//               background: t.hoverBg,
//               color: t.text,
//               cursor: "pointer",
//               display: "inline-flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <X size={16} />
//           </button>
//         </header>

//         <Field label="Target status">
//           <Select
//             value={targetStatus}
//             onChange={(e) => setTargetStatus(e.target.value)}
//             disabled={submitting}
//           >
//             {STATUS_FLOW.map((s, i) => (
//               <option key={s.value} value={s.value} disabled={i <= currentIdx}>
//                 {s.label}
//                 {i <= currentIdx ? "  (locked)" : ""}
//               </option>
//             ))}
//           </Select>
//         </Field>

//         {targetIdx >= FEE_TRIGGER_INDEX && selectedRows.length > 0 && (
//           <div
//             style={{
//               padding: 14,
//               borderRadius: 12,
//               background: anyLocked
//                 ? t.subtle
//                 : requiresFee
//                   ? t.warningBg
//                   : t.subtle,
//               border: `1px solid ${anyLocked
//                   ? t.border
//                   : requiresFee
//                     ? `${t.warning}55`
//                     : t.border
//                 }`,
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//                 marginBottom: 8,
//                 fontSize: 12,
//                 fontWeight: 800,
//                 letterSpacing: 0.3,
//                 textTransform: "uppercase",
//                 color: anyLocked
//                   ? t.muted
//                   : requiresFee
//                     ? t.warning
//                     : t.text,
//               }}
//             >
//               <Truck size={13} />
//               Shipping fee{" "}
//               {requiresFee
//                 ? `(${missingFee.length} item${missingFee.length === 1 ? "" : "s"
//                 } missing)`
//                 : "(already set)"}
//             </div>

//             {anyLocked ? (
//               <div style={{ fontSize: 12.5, color: t.muted, lineHeight: 1.5 }}>
//                 Some selected items already have shipping paid. Their fees are
//                 locked and will not be updated.
//               </div>
//             ) : (
//               <>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 8,
//                   }}
//                 >
//                   <div
//                     style={{
//                       position: "relative",
//                       display: "flex",
//                       alignItems: "center",
//                       flex: 1,
//                     }}
//                   >
//                     <span
//                       style={{
//                         position: "absolute",
//                         left: 12,
//                         fontWeight: 700,
//                         fontSize: 14,
//                         color: t.muted,
//                         pointerEvents: "none",
//                       }}
//                     >
//                       ₵
//                     </span>
//                     <Input
//                       type="number"
//                       min="0"
//                       step="0.01"
//                       value={feeInput}
//                       onChange={(e) => setFeeInput(e.target.value)}
//                       placeholder={
//                         requiresFee ? "Enter fee per unit" : "Fee per unit"
//                       }
//                       disabled={submitting}
//                       style={{ paddingLeft: 30 }}
//                     />
//                   </div>
//                 </div>
//                 <div
//                   style={{
//                     marginTop: 8,
//                     fontSize: 11.5,
//                     color: t.muted,
//                     lineHeight: 1.5,
//                   }}
//                 >
//                   This is the fee <strong>per unit</strong>. The buyer pays
//                   fee × quantity. Leave blank to keep any existing fee.
//                 </div>
//               </>
//             )}

//             {errors.fee && (
//               <div
//                 style={{
//                   marginTop: 8,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 6,
//                   fontSize: 11.5,
//                   color: t.error,
//                   fontWeight: 600,
//                 }}
//               >
//                 <AlertCircle size={12} />
//                 {errors.fee}
//               </div>
//             )}
//           </div>
//         )}

//         {errors._general && (
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 8,
//               padding: "10px 12px",
//               borderRadius: 10,
//               background: t.errorBg,
//               color: t.error,
//               fontSize: 12.5,
//               fontWeight: 600,
//             }}
//           >
//             <XCircle size={14} />
//             {errors._general}
//           </div>
//         )}

//         <div
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             gap: 10,
//             paddingTop: 4,
//           }}
//         >
//           <Button variant="secondary" onClick={onClose} disabled={submitting}>
//             Cancel
//           </Button>
//           <Button
//             type="submit"
//             icon={Save}
//             disabled={
//               submitting || !advancingForward || (requiresFee && !feeInput)
//             }
//           >
//             {submitting ? "Advancing…" : "Advance items"}
//           </Button>
//         </div>
//       </form>
//     </div>
//   );
// };


















// screens/marketplace/AdminOrderFulfillment.jsx
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Package,
  RefreshCw,
  Search,
  ChevronDown,
  ChevronRight,
  CheckCircle2,
  AlertCircle,
  Truck,
  Inbox,
  Wallet,
} from "lucide-react";
import { useAuth } from "../../providers/AuthProvider";
import { useToast } from "../../providers/ToastProvider";
import {
  PageShell,
  Button,
  Input,
  EmptyState,
  LoadingBlock,
  useTokens,
} from "./shared";

/* ══════════════════════════════════════════════════════════
   Pipeline statuses
   ══════════════════════════════════════════════════════════ */

const STATUS_FLOW = [
  { value: "ORDER_CONFIRMED", label: "Order Confirmed" },
  { value: "SHOPPING_IN_PROGRESS", label: "Shopping in Progress" },
  { value: "PURCHASED", label: "Purchased" },
  { value: "IN_TRANSIT_TO_CHINA", label: "In Transit to China Warehouse" },
  { value: "RECEIVED_AT_CHINA", label: "Received at China Warehouse" },
  { value: "INSPECTION_IN_PROGRESS", label: "Inspection in Progress" },
  { value: "PREPARING_FOR_SHIPMENT", label: "Preparing for Shipment" },
  { value: "SHIPPED_FROM_CHINA", label: "Shipped from China" },
  { value: "ARRIVED_IN_GHANA", label: "Arrived in Ghana" },
  { value: "READY_FOR_PICKUP", label: "Ready for Pickup" },
  { value: "OUT_FOR_DELIVERY", label: "Out for Delivery" },
  { value: "DELIVERED_SUCCESSFULLY", label: "Delivered Successfully" },
];

const TERMINAL_STATUSES = [
  { value: "FAILED", label: "Failed", tone: "error" },
  { value: "CANCELLED", label: "Cancelled", tone: "muted" },
];

const STATUS_BY_VALUE = Object.fromEntries(
  STATUS_FLOW.map((s, i) => [
    s.value,
    { ...s, index: i, tone: "info" },
  ])
);

const statusIndex = (value) => {
  const s = STATUS_BY_VALUE[value];
  return s ? s.index : -1;
};

/* ── Bug fix: return a proper tone for every status ── */
const statusMeta = (value) => {
  if (value === "FAILED") return { label: "Failed", tone: "error" };
  if (value === "CANCELLED") return { label: "Cancelled", tone: "muted" };
  if (value === "DELIVERED_SUCCESSFULLY")
    return { label: "Delivered Successfully", tone: "success" };
  if (value === "ARRIVED_IN_GHANA")
    return { label: "Arrived in Ghana", tone: "warning" };
  return STATUS_BY_VALUE[value] || { label: value || "Unknown", tone: "muted" };
};

const statusColor = (t, tone) => {
  const map = {
    error: { fg: t.error, bg: t.errorBg },
    muted: { fg: t.muted, bg: t.subtle },
    success: { fg: t.success, bg: t.successBg },
    warning: { fg: t.warning, bg: t.warningBg },
    info: { fg: t.accent, bg: t.hoverBg },
  };
  return map[tone] || map.muted;
};

const FEE_TRIGGER_INDEX = statusIndex("ARRIVED_IN_GHANA");

const isFeeEligibleStatus = (status) =>
  statusIndex(status) >= FEE_TRIGGER_INDEX && statusIndex(status) >= 0;

const itemNeedsFee = (item) =>
  isFeeEligibleStatus(item.status) &&
  (item.shipping_fee == null || Number(item.shipping_fee) === 0) &&
  item.shipping_payment_status !== "COMPLETED";

const readApiError = (data, fallback) => {
  if (!data) return fallback;
  if (data.message) return data.message;
  const errs = data.errors;
  if (errs) {
    const parts = [];
    for (const [key, val] of Object.entries(errs)) {
      const arr = Array.isArray(val) ? val : [val];
      arr.forEach((msg) => {
        if (key === "non_field_errors" || key === "detail") parts.push(msg);
        else parts.push(`${key.replace(/_/g, " ")}: ${msg}`);
      });
    }
    if (parts.length) return parts.join(" ");
  }
  return fallback;
};

export default function AdminOrderFulfillment() {
  const { authFetch } = useAuth();
  const { showToast } = useToast();
  const t = useTokens();

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [search, setSearch] = useState("");
  const [openGroups, setOpenGroups] = useState(
    () => new Set(["ARRIVED_IN_GHANA"])
  );
  const [showOnlyNeedsAction, setShowOnlyNeedsAction] = useState(false);

  const load = useCallback(
    async ({ silent } = {}) => {
      if (!silent) setLoading(true);
      else setRefreshing(true);
      try {
        const res = await authFetch("/marketplace/orders/");
        const data = await res.json();
        if (!res.ok) throw new Error(readApiError(data, "Could not load orders"));
        setOrders(data.data || []);
      } catch (err) {
        showToast(err.message, "error");
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    },
    [authFetch, showToast]
  );

  useEffect(() => {
    load();
  }, [load]);

  const allItems = useMemo(() => {
    const rows = [];
    orders.forEach((order) => {
      (order.items || []).forEach((item) => {
        rows.push({ order, item });
      });
    });
    return rows;
  }, [orders]);

  const filteredItems = useMemo(() => {
    const q = search.trim().toLowerCase();
    let list = allItems;

    if (showOnlyNeedsAction) {
      list = list.filter(({ item }) => {
        if (item.shipping_payment_status !== "COMPLETED") return false;
        const idx = statusIndex(item.status);
        return idx >= FEE_TRIGGER_INDEX && idx < 11;
      });
    }

    if (!q) return list;
    return list.filter(({ order, item }) => {
      return (
        (item.product_name_display || "").toLowerCase().includes(q) ||
        (order.id || "").toLowerCase().includes(q) ||
        (item.variant_key || "").toLowerCase().includes(q)
      );
    });
  }, [allItems, search, showOnlyNeedsAction]);

  const needsActionItems = useMemo(() => {
    return allItems.filter(({ item }) => {
      if (item.shipping_payment_status !== "COMPLETED") return false;
      const idx = statusIndex(item.status);
      return idx >= FEE_TRIGGER_INDEX && idx < 11;
    });
  }, [allItems]);

  const itemsAwaitingFee = useMemo(
    () => allItems.filter(({ item }) => itemNeedsFee(item)).length,
    [allItems]
  );

  const grouped = useMemo(() => {
    const map = new Map();
    STATUS_FLOW.forEach((s) => map.set(s.value, []));
    TERMINAL_STATUSES.forEach((s) => map.set(s.value, []));
    filteredItems.forEach(({ order, item }) => {
      const key = STATUS_BY_VALUE[item.status] ? item.status : "FAILED";
      if (!map.has(key)) map.set(key, []);
      map.get(key).push({ order, item });
    });
    const ordered = [];
    [...STATUS_FLOW, ...TERMINAL_STATUSES].forEach((s) => {
      const rows = map.get(s.value) || [];
      if (rows.length > 0) ordered.push({ status: s.value, rows });
    });
    return ordered;
  }, [filteredItems]);

  const toggleGroup = (status) => {
    setOpenGroups((prev) => {
      const next = new Set(prev);
      if (next.has(status)) next.delete(status);
      else next.add(status);
      return next;
    });
  };

  return (
    <PageShell
      eyebrow="Fulfilment"
      title="Order pipeline"
      subtitle="Items are grouped by their current stage. Open an order to advance its items and set shipping fees once they arrive."
      actions={
        <Button
          variant="secondary"
          icon={RefreshCw}
          onClick={() => load({ silent: true })}
          disabled={refreshing}
        >
          Refresh
        </Button>
      }
    >
      {/* ── Search + alerts ─────────────────────────── */}
      <div style={styles.toolbar}>
        <div style={{ position: "relative", flex: 1, maxWidth: 440 }}>
          <Search
            size={15}
            color={t.muted}
            style={{
              position: "absolute",
              left: 12,
              top: "50%",
              transform: "translateY(-50%)",
              pointerEvents: "none",
            }}
          />
          <Input
            placeholder="Search by product, order id, or variant…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ paddingLeft: 36 }}
          />
        </div>
      </div>

      {/* ── Alert strip: needs fee ─────────────────── */}
      {!loading && itemsAwaitingFee > 0 && (
        <div style={styles.alertStrip(t, "warning")}>
          <span style={styles.alertIcon(t, "warning")}>
            <Wallet size={16} />
          </span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={styles.alertTitle(t)}>
              {itemsAwaitingFee} item
              {itemsAwaitingFee === 1 ? "" : "s"} awaiting a shipping fee
            </div>
            <div style={styles.alertSubtitle(t)}>
              Open the order to set the fee and unblock the buyer.
            </div>
          </div>
        </div>
      )}

      {/* ── Alert strip: needs action (shipping paid) ─ */}
      {!loading && needsActionItems.length > 0 && (
        <div style={styles.alertStrip(t, "success")}>
          <span style={styles.alertIcon(t, "success")}>
            <CheckCircle2 size={16} />
          </span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={styles.alertTitle(t)}>
              {needsActionItems.length} item
              {needsActionItems.length === 1 ? "" : "s"} paid for shipping
            </div>
            <div style={styles.alertSubtitle(t)}>
              Ready to advance — the buyer has paid their shipping fee.
            </div>
          </div>
          <button
            type="button"
            onClick={() => setShowOnlyNeedsAction((v) => !v)}
            style={styles.alertBtn(t, showOnlyNeedsAction)}
          >
            {showOnlyNeedsAction ? "Show all" : "Show only these"}
          </button>
        </div>
      )}

      {/* ── Groups ─────────────────────────────────── */}
      {loading ? (
        <LoadingBlock label="Loading orders…" />
      ) : grouped.length === 0 ? (
        <EmptyState
          icon={Inbox}
          title={search ? "Nothing matches" : "No open items"}
          description={
            search
              ? "Try a different search term."
              : "Once buyers place orders, items will appear here grouped by their current stage."
          }
        />
      ) : (
        <div style={{ display: "grid", gap: 10 }}>
          {grouped.map((group) => {
            const meta = statusMeta(group.status);
            const tone = statusColor(t, meta.tone);
            const open = openGroups.has(group.status);
            const needsAttention =
              group.status === "ARRIVED_IN_GHANA" &&
              group.rows.some(({ item }) => itemNeedsFee(item));
            const feeCount = group.rows.filter(({ item }) =>
              itemNeedsFee(item)
            ).length;

            return (
              <div
                key={group.status}
                style={{
                  borderRadius: 12,
                  border: `1px solid ${
                    needsAttention ? `${t.warning}66` : t.border
                  }`,
                  background: t.surfaceRaised,
                  overflow: "hidden",
                }}
              >
                <button
                  type="button"
                  onClick={() => toggleGroup(group.status)}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    padding: "14px 16px",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    fontFamily: "inherit",
                    textAlign: "left",
                  }}
                >
                  {open ? (
                    <ChevronDown size={16} color={t.muted} />
                  ) : (
                    <ChevronRight size={16} color={t.muted} />
                  )}
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 800,
                      color: t.heading,
                    }}
                  >
                    {meta.label}
                  </span>
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      padding: "2px 8px",
                      borderRadius: 999,
                      background: tone.bg,
                      color: tone.fg,
                    }}
                  >
                    {group.rows.length}
                  </span>
                  {needsAttention && (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 4,
                        fontSize: 11,
                        fontWeight: 700,
                        color: t.warning,
                        padding: "2px 8px",
                        borderRadius: 999,
                        background: t.warningBg,
                      }}
                    >
                      <AlertCircle size={11} />
                      {feeCount} needs fee
                    </span>
                  )}
                </button>

                {open && (
                  <div
                    style={{
                      padding: "0 16px 14px",
                      borderTop: `1px solid ${t.separator || t.border}`,
                    }}
                  >
                    <GroupItems status={group.status} rows={group.rows} t={t} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </PageShell>
  );
}

/* ══════════════════════════════════════════════════════════
   Items inside one status group
   ══════════════════════════════════════════════════════════ */

const GroupItems = ({ status, rows, t }) => {
  const navigate = useNavigate();

  const byOrder = useMemo(() => {
    const map = new Map();
    rows.forEach(({ order, item }) => {
      if (!map.has(order.id)) map.set(order.id, { order, items: [] });
      map.get(order.id).items.push(item);
    });
    return [...map.values()];
  }, [rows]);

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          padding: "10px 0",
        }}
      >
        <span style={{ fontSize: 11.5, color: t.muted }}>
          {rows.length} item{rows.length === 1 ? "" : "s"} across{" "}
          {byOrder.length} order{byOrder.length === 1 ? "" : "s"}
        </span>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        {byOrder.map(({ order, items: orderItems }) => {
          const feeMissing = orderItems.filter((it) =>
            itemNeedsFee(it)
          ).length;
          return (
            <button
              key={order.id}
              type="button"
              onClick={() =>
                navigate(`/marketplace/manage/orders/${order.id}`)
              }
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                width: "100%",
                padding: "12px 14px",
                borderRadius: 10,
                border: `1px solid ${t.border}`,
                background: t.raisedBg,
                cursor: "pointer",
                fontFamily: "inherit",
                textAlign: "left",
                transition:
                  "border-color 0.15s ease, background 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = t.accent;
                e.currentTarget.style.background = t.hoverBg;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = t.border;
                e.currentTarget.style.background = t.raisedBg;
              }}
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  background: t.subtle,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  color: t.muted,
                }}
              >
                <Package size={15} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: t.heading,
                  }}
                >
                  #{String(order.id).slice(0, 8)} ·{" "}
                  {order.customer_username || "customer"}
                </div>
                <div
                  style={{
                    fontSize: 11.5,
                    color: t.muted,
                    marginTop: 2,
                  }}
                >
                  {orderItems.length} item
                  {orderItems.length === 1 ? "" : "s"} at this stage
                  {feeMissing > 0 && (
                    <span
                      style={{
                        marginLeft: 6,
                        color: t.warning,
                        fontWeight: 700,
                      }}
                    >
                      · {feeMissing} needs fee
                    </span>
                  )}
                </div>
              </div>
              <ChevronRight size={16} color={t.muted} />
            </button>
          );
        })}
      </div>
    </>
  );
};

/* ══════════════════════════════════════════════════════════
   Reusable ItemRow (exported for order detail reuse)
   ══════════════════════════════════════════════════════════ */

export const ItemRow = ({
  order,
  item,
  t,
  selectable = false,
  selected,
  busy,
  onToggle,
}) => {
  const navigate = useNavigate();
  const needsFee = itemNeedsFee(item);
  const locked = item.shipping_payment_status === "COMPLETED";
  const fee = item.shipping_fee != null ? Number(item.shipping_fee) : null;
  const feeTotal =
    item.shipping_total != null ? Number(item.shipping_total) : null;

  const goToOrder = () =>
    navigate(`/marketplace/manage/orders/${order.id}`);

  return (
    <div
      onClick={selectable ? onToggle : goToOrder}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 12px",
        borderRadius: 10,
        border: `1px solid ${selected ? t.accent : t.border}`,
        background: selected ? `${t.accent}0A` : t.raisedBg,
        cursor: "pointer",
        opacity: busy ? 0.55 : 1,
        transition: "background 0.12s ease, border-color 0.12s ease",
      }}
    >
      {selectable && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            onToggle?.();
          }}
          style={{
            width: 18,
            height: 18,
            borderRadius: 5,
            border: `1.5px solid ${selected ? t.accent : t.border}`,
            background: selected ? t.accent : "transparent",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {selected && (
            <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
              <path
                d="M2 6.5L4.5 9L10 3"
                stroke={t.accentText}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
      )}

      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 8,
          overflow: "hidden",
          background: t.subtle,
          flexShrink: 0,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {item.product_image ? (
          <img
            src={item.product_image}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <Package size={16} color={t.muted} />
        )}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 13,
            fontWeight: 700,
            color: t.heading,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {item.product_name_display || item.product_name || "Product"}{" "}
          <span style={{ color: t.muted, fontWeight: 500 }}>
            ×{item.quantity}
          </span>
        </div>
        <div
          style={{
            fontSize: 11,
            color: t.muted,
            marginTop: 2,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          #{String(order.id).slice(0, 8)} ·{" "}
          {item.variant_key ? item.variant_key : "no variant"} ·{" "}
          {order.customer_username || order.customer || "customer"}
        </div>
      </div>

      <div style={{ flexShrink: 0, textAlign: "right" }}>
        {needsFee ? (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              fontSize: 11,
              fontWeight: 700,
              color: t.warning,
              padding: "3px 8px",
              borderRadius: 999,
              background: t.warningBg,
            }}
          >
            <AlertCircle size={11} />
            Fee unset
          </span>
        ) : fee != null ? (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              fontSize: 11,
              fontWeight: 700,
              color: locked ? t.success : t.text,
              padding: "3px 8px",
              borderRadius: 999,
              background: locked ? t.successBg : t.subtle,
            }}
          >
            {locked ? <CheckCircle2 size={11} /> : <Truck size={11} />}₵
            {fee.toFixed(2)}/unit
            {feeTotal != null && (
              <span style={{ color: t.muted, fontWeight: 500 }}>
                · ₵{feeTotal.toFixed(2)}
              </span>
            )}
          </span>
        ) : null}
      </div>

      <ChevronRight size={16} color={t.muted} />
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   Styles
   ══════════════════════════════════════════════════════════ */

const styles = {
  toolbar: {
    display: "flex",
    gap: 12,
    marginBottom: 16,
    flexWrap: "wrap",
  },
  alertStrip: (t, variant) => {
    const map = {
      warning: {
        bg: `${t.warning}12`,
        border: `${t.warning}55`,
      },
      success: {
        bg: `${t.success}12`,
        border: `${t.success}55`,
      },
    };
    const v = map[variant] || map.warning;
    return {
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "12px 14px",
      borderRadius: 12,
      background: v.bg,
      border: `1px solid ${v.border}`,
      marginBottom: 12,
    };
  },
  alertIcon: (t, variant) => ({
    width: 32,
    height: 32,
    borderRadius: 9,
    background: variant === "success" ? t.success : t.warning,
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  }),
  alertTitle: (t) => ({
    fontSize: 13,
    fontWeight: 800,
    color: t.heading,
  }),
  alertSubtitle: (t) => ({
    fontSize: 12,
    color: t.muted,
    marginTop: 2,
  }),
  alertBtn: (t, active) => ({
    fontSize: 12,
    fontWeight: 700,
    color: t.success,
    background: active ? t.successBg : "transparent",
    border: active ? `1px solid ${t.success}55` : "none",
    cursor: "pointer",
    padding: "6px 12px",
    borderRadius: 8,
    fontFamily: "inherit",
  }),
};